/* badge-container.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._2I62gz5UaJ%7Binset-block-start%3Avar(--ds-space-negative-050%2C-4px)%7D%0A._3iC0zd8HPE%7Binset-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._1pp6NdYbGa%7Bpointer-events%3Anone%7D");






import type { ComponentType, ReactNode } from 'react';
const styles = {
  root: "_1mT5xdRAKS _3iDTPbQ4SZ",
  badgeContainer: "_1mT5xdWVPG _1ANEUSLRg7 _2I62gz5UaJ _3iC0zd8HPE _1pp6NdYbGa"
};
type BadgeContainerProps = {
  /* The id of the badge */
  id: string;

  /* The component to render as the badge */
  badge: ComponentType;

  /**
   * The children to render inside the container that the badge overlays.
   */
  children: ReactNode;

  /**
   * Can be used to disable the default `listitem` role.
   *
   * As `BadgeContainer` is used internally to wrap `EndItem`, this prop is used to respect
   * the `isListItem` prop value set in `EndItem`.
   *
   * See the prop description in `EndItem` for more information.
   *
   * @default true
   */
  isListItem?: boolean;
};

/**
 * __Badge container__
 *
 * Adds a badge to the top right corner of the child element.
 * Example of usage is showing the number of notifications in the top navigation bar.
 */
export const BadgeContainer: (props: BadgeContainerProps) => JSX.Element = ({
  children,
  id: badgeId,
  badge: Badge,
  isListItem = true
}: BadgeContainerProps) => <div role={isListItem ? 'listitem' : undefined} className={ax([styles.root])}>
		{children}
		<div id={badgeId} aria-hidden className={ax([styles.badgeContainer])}>
			<Badge />
		</div>
	</div>;